var ACTDIG = ACTDIG || (ACTDIG = {});

ACTDIG.Home = (function ($, window, document) {

    return {
        init: function () {

        }
    };
})(window.jQuery, window, document);